import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CcLineSummaryDto } from '../../../data/models/cc-line-summary-dto';
import { LineDetailsDto } from '../../../data/models/line-details-dto';
import { LinePerformanceStatisticsDto } from '../../../data/models/line-performance-statistics-dto';
import { AccountLineSubjectService } from '../../../services/account-line-subject.service';
import { LineStatisticsService } from '../../../services/line-statistics.service';

@Component({
  selector: 'app-cc-line-statistics',
  templateUrl: './cc-line-statistics.component.html',
  styleUrls: ['./cc-line-statistics.component.scss'],
  providers: [MessageService]
})
export class CcLineStatisticsComponent implements OnInit {
  @Input() line: CcLineSummaryDto;
  @Input() isPair: boolean;
  @Input() parentLine: CcLineSummaryDto;
  lineStats: LinePerformanceStatisticsDto;
  loading: boolean = false;

  //loader:boolean = false;

  constructor(private lineStatsService: LineStatisticsService, private messageService: MessageService, private accountLineChangesService: AccountLineSubjectService) { }

  ngOnInit() {
  //  //if (!this.line)
  //  //  this.accountLineChangesObserver();
  //   (this.isPair) ? this.getLineStatistics(/*this.parentLine*/) :
  //     (this.line) ? this.getLineStatistics(/*this.line*/) : null;  //31453 ,14781 , 15107
  }
  ngOnChanges() {
    (this.isPair) ? this.getLineStatistics(/*this.parentLine*/) :
      (this.line) ? this.getLineStatistics(/*this.line*/) : null;  //31453 ,14781 , 15107
  }

  ///`LineDetails/get-line-statistics/`
  getLineStatistics(/*line: CcLineSummaryDto*/) {
    //this.loader = true;

    let object = {
      id: this.line.id,
      ip: this.line.ipAddress,
      speed: this.isPair ? this.parentLine.lineSpeed : this.line.lineSpeed ,
      isPair: this.isPair,
      pairNum: this.line.pairNum,
      ismonitored: this.line.isMonitored
    }
    this.loading = true;
    this.lineStatsService.getLineStatisticsById(object).subscribe((res: LinePerformanceStatisticsDto) => {
      this.lineStats = res;
      this.loading = false;
      
    }, (error) => {
      this.loading = false;
      
      this.messageService.add({ severity: 'error', summary: 'Get Line Statistics', detail:'could not get stats now' })
    });
  }

  //accountLineChangesObserver() {
  //  this.accountLineChangesService.notifyChangesInSelectedLine.subscribe((res: LineDetailsDto) => {
  //    if (res) {
  //      //get data again
  //      this.line = res;
  //      this.getLineStatistics(res);
  //    }
  //    //this.loader = false;
  //  }, (error) => {
  //    //this.loader = false;
  //    this.messageService.add({ severity: 'error', summary: 'Account Line Changes Observer', detail: 'Could not retrieve line Sammry data' });
  //  })
  //}
}
